module.exports = __webpack_public_path__ + "img/violet_056.46506019.png";